<template>
    <!-- Pdf preview -->
    <div v-if="isPdfPreview" class="form-control">
        {{ getSelectedValue(currentValue) }}
    </div>
    <!-- Select -->
    <div v-show="isShowing" v-else>
        <div v-if="searchable">
            <MultiSelect
                :id="name"
                v-model="selectedItem"
                :name="name"
                track-by="value"
                :label="keyText"
                :class="className"
                :placeholder="placeholder"
                :options="options"
                select-label=""
                deselect-label=""
                :disabled="readonly"
                aria-selected="true"
                @input="onMultiSelectChange"
            />
        </div>
        <select v-else v-model="currentValue" class="form-control" :name="name" @change="onChange($event)">
            <option value="">
                {{ placeholder }}
            </option>
            <option v-for="item in options" :key="item[keyValue]" :value="item[keyValue]">
                {{ item[keyText] }}
            </option>
        </select>
    </div>
</template>
<script>
import MultiSelect from 'vue-multiselect'
export default {
    name: 'AppSelect',
    components: {
        MultiSelect,
    },
    props: {
        value: { type: [Number, String], default: '' },
        options: { type: Array, required: true, default: () => [] },
        placeholder: {
            type: String,
            default: 'Please select',
        },
        name: { type: String, required: false, default: '' },
        searchable: Boolean,
        className: { type: Object, default: () => null },
        keyValue: {
            type: String,
            default: 'value',
        },
        keyText: {
            type: String,
            default: 'text',
        },
        nonObjectModel: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isPdfPreview: false,
            isShowing: true,
        }
    },

    computed: {
        currentValue() {
            return this.value || ''
        },
        selectedItem() {
            if (this.nonObjectModel) {
                return this.value
            }
            return this.options.find((i) => i[this.keyValue] == this.value)
        },
        // placeHolder() {
        //   return this.placeholder.join(' | ')
        // }
    },

    watch: {
        options() {
            this.isShowing = false
            this.isShowing = true
        },
    },
    mounted() {
        this.isPdfPreview = this.$root.inPdfPreviewForm(this.$el)
    },
    mounted() {
        this.isPdfPreview = this.$root.inPdfPreviewForm(this.$el)
    },
    methods: {
        onChange(e) {
            const changeValue = parseInt(e.target.value)
            this.$emit('input', isNaN(changeValue) ? e.target.value : changeValue)
        },
        onMultiSelectChange(item) {
            this.$emit('input', item[this.keyValue])
        },

        /**
         * Get selected text value for PDF preview
         */
        getSelectedValue(selectedValue) {
            let optionSelectedValue = this.options.find((v) => v[this.keyValue] == selectedValue)
            return optionSelectedValue ? optionSelectedValue[this.keyText] : 'Not selected'
        },
    },
}
</script>
<style>
.multiselect__tags {
    padding: 5px 40px 0 8px !important;
}
</style>
